import { render } from "./showUserCard.vue?vue&type=template&id=76d6810d&scoped=true"
import script from "./showUserCard.vue?vue&type=script&lang=js"
export * from "./showUserCard.vue?vue&type=script&lang=js"

import "./showUserCard.vue?vue&type=style&index=0&id=76d6810d&lang=scss&scoped=true"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76d6810d"]])

export default __exports__